import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import CarouselMain from '../components/CarouselMain';

function CarouselGet() {
  const [response, setResponse] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchResponse = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/site/carousel`);
        setResponse(response.data || []);
      } catch (err) {
        setError('No se pudo cargar el contenido.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchResponse();
  }, []);

  if (loading) {
    return (
      <div>
        <Container>Cargando...</Container>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <Container>{error}</Container>
      </div>
    );
  }

  return (
    <CarouselMain banner_list={response} />
  );
}

export default CarouselGet;